import { render, staticRenderFns } from "./MenuLayout.vue?vue&type=template&id=12911e1e&"
import script from "./MenuLayout.vue?vue&type=script&lang=js&"
export * from "./MenuLayout.vue?vue&type=script&lang=js&"
import style0 from "./MenuLayout.vue?vue&type=style&index=0&id=12911e1e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDrawer,QScrollArea,QList,QSeparator,QItem,QItemSection,QIcon});qInstall(component, 'directives', {Ripple});
